
import { useIntelligentEnrichmentPolling } from '@/hooks/useIntelligentEnrichmentPolling';
import { Client } from '@/components/clients/types'; // For typing props
import { BackendProgressStage } from '@/components/clients/enrichment-dialog/enrichmentTypes';

interface UseEnrichmentPollingControllerProps {
  client: Client | undefined | null;
  runId: string | undefined;
  lastEnrichmentData: { progress_stage?: BackendProgressStage | string | null; [key: string]: any } | null;
  onUpdate: (data: any) => void;
  onComplete: (data: any) => void;
  onError: (errorMessage: string, errorDetails?: any, rawData?: any) => void;
}

const STAGES_REQUIRING_POLLING: Array<BackendProgressStage | string> = [
  'queued',
  'requested', // Polling might start if agent sets to pending_poll quickly
  'initiated_lutra', // If Lutra provides a results URL immediately
  'processing', // If Lutra provides a results URL and is in this generic state
  'extracting', // If Lutra provides a results URL
  'finalizing', // If Lutra provides a results URL
  'pending_lutra_data', // Explicitly waiting for Lutra data (often implies polling will start)
  'polling_for_results' // Actively polling
];

export const useEnrichmentPollingController = ({
  client,
  runId,
  lastEnrichmentData,
  onUpdate,
  onComplete,
  onError,
}: UseEnrichmentPollingControllerProps) => {

  const currentProgressStage = lastEnrichmentData?.progress_stage || client?.enrichment_status;

  const isPollingEnabled = !!client && !!runId && (
    client.enrichment_status === 'pending_poll' || // DB explicitly says to poll
    (client.enrichment_status === 'pending' && STAGES_REQUIRING_POLLING.includes(currentProgressStage || '')) ||
    STAGES_REQUIRING_POLLING.includes(currentProgressStage || '')
  );
  
  console.log(`[PollingController] Client: ${client?.id}, RunID: ${runId}, Stage: ${currentProgressStage}, PollingEnabled: ${isPollingEnabled}`);

  const { isPolling, stopPolling } = useIntelligentEnrichmentPolling({
    clientId: client?.id,
    runId: runId,
    isEnabled: isPollingEnabled,
    onEnrichmentUpdate: onUpdate,
    onEnrichmentComplete: onComplete,
    onEnrichmentError: onError,
  });

  return {
    isPolling,
    stopPolling,
  };
};
